/**
 * Test IDs for QA automation.
 */
export const testIds = {
  stateSelectAllOption: "state-select-all-option",
  stateSelectUnitedStatesOption: "state-select-united-states-option",
  stateSelectCanadaOption: "state-select-canada-option",
} as const;
